(function() {


  const initSlider = () => {
    const sliders = document.querySelectorAll('.blog__slider');

    sliders.forEach((slider, index) => {
      const articlesSlider = new Swiper(slider, {
        slidesPerView: 1,
        spaceBetween: 30,
        speed: 1000,
        loop: false,
        navigation: {
          nextEl: ".testi__slider-nav .swiper-button-next",
          prevEl: ".testi__slider-nav .swiper-button-prev",
        },
        breakpoints: {
          576: {
            slidesPerView: 2.05,
            slidesPerGroup: 1
          },
          990: {
            slidesPerView: 3.05,
            slidesPerGroup: 1
          },
          1200: {
            slidesPerView: 3,
            slidesPerGroup: 1
          }
        }
      })
    })
  }

initSlider();


  document.addEventListener('shopify:section:load', function () {
   initSlider();
  });
})()